import React from 'react'
import PropTypes from 'prop-types'

const PlanViewer = ({ backgroundUrl, pins }) => {
  const points = pins || []

  if (!backgroundUrl)
    return <div className="text-muted small">Aucun plan disponible pour cette ressource.</div>

  return (
    <div className="plan-viewer">
      <div className="plan-viewer-canvas">
        <img src={backgroundUrl} alt="Plan de la ressource" className="img-fluid" />
        {points.map(pin => (
          <span
            key={pin.id}
            className="plan-pin"
            style={{ left: `${pin.posX * 100}%`, top: `${pin.posY * 100}%` }}
          />
        ))}
      </div>
      {points.length === 0 &&
        <div className="text-muted small mt-1">Aucun point positionné.</div>}
    </div>
  )
}

PlanViewer.propTypes = {
  backgroundUrl: PropTypes.string,
  pins: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    posX: PropTypes.number,
    posY: PropTypes.number
  }))
}

PlanViewer.defaultProps = {
  backgroundUrl: null,
  pins: []
}

export default PlanViewer
